import { psaInitialFormData } from "@/utils/enum";
import { createSlice } from "@reduxjs/toolkit";

export interface GiFilterState {
  schools: any;
  grades: any;
  boardId: any;
  currentPage: any;
  giEventsCount: any;
  giEvents: [];
  giSearchData: any;
  studentId: any;

  dob: any;
  gender: any;
  enrollmentNumber: any;
  firstName: any;
  lastName: any;
  email: any;
  phoneNumber: any;
  studentType: any;
  schoolName: any;
  guardianEvents: boolean;
}

const initialState: GiFilterState = {
  schools: null,
  grades: null,
  boardId: "",
  dob: "",
  gender: "",
  enrollmentNumber: "",
  firstName: "",
  lastName: "",
  email: "",
  phoneNumber: "",
  studentType: "",
  studentId: "",
  schoolName: "",
  guardianEvents: false,
  currentPage: 1,
  giEventsCount: 0,
  giEvents: [],
  giSearchData: { ...psaInitialFormData },
};

const giFilterSlice = createSlice({
  name: "giFilter",
  initialState,
  reducers: {
    addFilter: (state, action) => {
      return { ...state, ...action.payload };
    },
    setGiEventsCount: (state, action) => {
      state.giEventsCount = action.payload;
    },
    setGiEvents: (state, action) => {
      state.giEvents = action.payload;
    },
    setGiSearchData: (state, action) => {
      state.giSearchData = action.payload;
    },
    clearGiData: (state) => {
      return {
        ...initialState,
      };
    },
    clearGiFilters: (state) => {
      state.schools = null;
      state.grades = null;
      state.boardId = "";
      state.dob = "";
      state.gender = "";
      state.enrollmentNumber = "";
      state.firstName = "";
      state.lastName = "";
      state.email = "";
      state.phoneNumber = "";
      state.studentType = "";
      state.schoolName = "";
      state.guardianEvents = false;
      state.giEvents = [];
      state.studentId = "";
    },
  },
});

export const {
  addFilter,
  setGiEventsCount,
  setGiEvents,
  setGiSearchData,
  clearGiData,
  clearGiFilters,
} = giFilterSlice.actions;
export const giFilterItems = (state: any) => state.giFilter;
export default giFilterSlice.reducer;
